import React, { useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import { mapboxConfig } from '../../mapbox/config';
import './Geocoder.scoped.scss';

mapboxgl.accessToken = mapboxConfig.accessToken;

function Geocoder({ map }) {
    const geocoderContainerRef = useRef(null);

    useEffect(() => {
        if (map && geocoderContainerRef.current) {
            const geocoder = new MapboxGeocoder({
                accessToken: mapboxgl.accessToken,
                mapboxgl: mapboxgl,
                marker: false
            });

            // Append geocoder to the container instead of adding it to the map
            geocoderContainerRef.current.appendChild(geocoder.onAdd(map));

            // Optional: If you want to handle the result of the geocoding and change the map view
            geocoder.on('result', function(e) {
                map.flyTo({
                    center: e.result.geometry.coordinates
                });
            });
        }
    }, [map]);

    // Render a container div for the Geocoder
    return <div ref={geocoderContainerRef}></div>;
}

export default Geocoder;